const TOGGLE_SUBSCRIPT = 'TOGGLE_SUBSCRIPT';
const TOGGLE_SUPERSCRIPT = 'TOGGLE_SUPERSCRIPT';
const CLEAR_XSCRIPT = 'CLEAR_XSCRIPT';
const ONLY_HIGHLIGHT_SUBSCRIPT = 'ONLY_HIGHLIGHT_SUBSCRIPT';
const ONLY_HIGHLIGHT_SUPERSCRIPT = 'ONLY_HIGHLIGHT_SUPERSCRIPT';

export const highLightSubscript = () => ({ type: TOGGLE_SUBSCRIPT });
export const highLightSuperscript = () => ({
  type: TOGGLE_SUPERSCRIPT,
});
export const onlyHighLightSubscript = () => ({
  type: ONLY_HIGHLIGHT_SUBSCRIPT,
});
export const onlyHighLightSuperscript = () => ({
  type: ONLY_HIGHLIGHT_SUPERSCRIPT,
});
export const clearXscriptHighLight = () => ({
  type: CLEAR_XSCRIPT,
});
